/**
 * Inactivity Timeout model
 */

define(function(require) {
    var BaseModel = require('common/base.model'),
        server = require('server');

    return BaseModel.extend({

        parse: function(resp) {
            return resp.data;
        },

        sync: function(method, model, options) {
            if (method === 'read') {
                return this.getTimeout()
                    .done(options.success)
                    .fail(options.error);
            }

            return this.setTimeout();
        },

        getTimeout: function() {
            return server.send({
                ID: 81111,
                description: 'Get Player Login Info Request (inactivity timeout)',
                requestedPlayerData: [5],
                responses: [81113 , 81100]
            });
        },

        setTimeout: function() {
            return server.send({
                ID: 81112,
                description: 'Change Player Login Info Request (inactivity timeout)',
                changeId: Date.now(),
                dataVersion: this.get('dataVersion'),
                playerDataMap: {
                    inactivityTimeout: this.get('inactivityTimeout')
                },
                responses: [81114, 81100]
            });
        }
    });

});

